import { Fieldset, Grid, NumberInput, Select, Space } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconArrowsSort, IconPercentage } from '@tabler/icons-react';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

type PercentagePriceChangeFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
};

const roundingOptions = [
	{ label: 'Nearest penny', value: 'nearest' },
	{ label: 'Round up', value: 'up' },
	{ label: 'Round down', value: 'down' },
];

export function PercentagePriceChangeForm({
	form,
}: PercentagePriceChangeFormProps) {
	return (
		<>
			<Fieldset legend={'Percentage change'}>
				<Grid>
					<Grid.Col span={12}>
						<NumberInput
							label={'Percentage'}
							placeholder={'Insert percentage to apply to price inc. VAT...'}
							key={form.key('percentage')}
							{...form.getInputProps('percentage')}
							decimalScale={2}
							suffix="%"
							leftSection={<IconPercentage {...defaultIconStyle} />}
							allowNegative={true}
							thousandSeparator={','}
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<Select
							label={'Rounding'}
							placeholder={'Select rounding mode...'}
							data={roundingOptions}
							leftSection={<IconArrowsSort {...defaultIconStyle} />}
							key={form.key('roundingMode')}
							{...form.getInputProps('roundingMode')}
							allowDeselect={false}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}